document.addEventListener('DOMContentLoaded', function () {
  (function (document) {
    let vFlashMessage;
    let destroyFlashMessage;
    let messageTemplate = document.createElement('div');
    let body = document.body;
    let vFlashMessageId = 'v-flash-message';

    vFlashMessage = function (text, myClass = '') {
      messageTemplate.innerHTML = `<div id='${vFlashMessageId}' class='alert fixed-alert ${myClass}' role='alert' style='z-index:99999'><span>${text}</span></div>`;

      body.prepend(messageTemplate);
      setTimeout(function () { destroyFlashMessage(messageTemplate); }, 3000);
    };

    destroyFlashMessage = function (element) {
      if (element) {
        element.remove();
      }
    };

    window.vFlashMessage = vFlashMessage;
  }(document));
});



// WEBPACK FOOTER //
// ./app/webpacker/src/js/modules/flash_messages.js